import router from "./router";
import store from "./store";
import enumObject from "./utils/enum";
import { getUrlParam, isWeiXin, isZhiFuBao, parseTime } from "@/utils";
import { getToken } from "@/utils/auth";
import { getAccessByCode } from "@/api/wechat";
import config from "./config";
const AppId = enumObject.providerConfig[config.projectName].AppIds;
const ZfbId = enumObject.providerConfig[config.projectName].ZfbId;
const isCrossPlatform =
  enumObject.providerConfig[config.projectName].CrossPlatform;

const whiteList = [
  "/",
  "/login",

]; // no redirect whitelist

const needWxAuth = isWeiXin(); //WeChat
const needAlipayAuth = isZhiFuBao(); //Alipay
router.beforeEach(async (to, from, next) => {
  /* 路由发生变化修改页面title */
  document.title = to.meta.title ? to.meta.title : "";
  if (!store.getters.cvs) {
    store.dispatch("ClearSession");
    store.dispatch("SetCvs");
    location.reload();
  } else {
    const hasPhone = store.getters.NBPSS && store.getters.NBPSS.phone;
    const hasToken = store.getters.token;
    // determine whether the user has logged in
    if (hasToken) {
      if (to.path === "/login" && hasPhone) {
        if (to.query.redirect) {
          next({ path: to.query.redirect });
        } else {
          next({ path: "/" });
        }
        // if is logged in, redirect to the home page
      } else {
        getAuth(to, from, next);
      }
    } else {
      console.log("NoToken " + hasToken);
      getAuth(to, from, next);
    }
  }
});
async function getAuth (to, from, next) {
  const hasPhone = store.getters.NBPSS && store.getters.NBPSS.phone;
  const hasOpenid = store.getters.NBPSS && store.getters.NBPSS.openid;
  /**
   * go auth
   * 1:By Oauth2; 2:By Phone;
   */
  if (needWxAuth) {
    //Need WeChat auth and login or register
    if (!hasOpenid || !getToken("NineBit_Authorization")) await wxAuthMethod(to.name);
  } else if (needAlipayAuth) {
    //Need Alipay auth and login or register
    if (config.projectName == "CTC" || config.projectName == "ZTS" || config.projectName == "JNJT" || config.projectName == "SXT") {
      if (!hasOpenid || !getToken("NineBit_Authorization"))
        await zfbAuthMethod();
    }
  } else {
    //Other Browser & Other Pay
    console.log("Other Browser");
  }
  analyticsRequest(to, from); //PV & Init of AD
  /**
   * Login By Phone;
   * Determine whether the user is bound to a mobile phone or
   * in the free login whitelist, go directly
   */
  if (isCrossPlatform) {
    if (hasPhone || whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next(`/login?redirect=${to.path}`);
    }
  } else {
    next();
  }
}
// 支付宝鉴权
async function zfbAuthMethod () {
  const code = {
    appid: ZfbId,
    authCode: getUrlParam("auth_code") || null
  };
  let local = window.location.href;
  let zfbData = store.getters.zfb_userInfo;
  if (code.authCode == null || code.authCode == "") {
    getAccessByCode(code.appid, local, "zfb"); //获取支付宝code
  } else {
    // 通过接口获取openid、access_token、expires_in、refresh_token、scope
    zfbData = await store.dispatch("zfbAuthentication", code);
    if (!zfbData.userId) {
      if (local.indexOf("?") != -1) {
        local = local.split("?")[0];
      }
      window.location.href = local; // 重新获取code
    }
  }
  // code正常则保存微信鉴权和用户数据


  let userData = await store.dispatch("Login", { openid: zfbData.userId });

  // 如果获取不到用户信息 就注册
  if (!userData) {
    // 如果获取不到用户信息 就注册然后登录
    let registerRes = await store.dispatch("Register", {
      openid: zfbData.userId
    }); //注册
    await store.dispatch("Login", {
      openid: registerRes && registerRes.userId
    }); //登录
  }
}
// 微信鉴权
async function wxAuthMethod () {
  const code = getUrlParam("code") || null;
  let local = window.location.href;
  let wxData = store.getters.wx_userInfo;
  // 通过接口获取openid、access_token、expires_in、refresh_token、scope
  if ((code == null || code == "")) {
    getAccessByCode(AppId, local, "wx"); //获取微信code
  } else {
    // 通过接口获取openid、access_token、expires_in、refresh_token、scope
    wxData = await store.dispatch("wxAuthentication", { code });
    if (!wxData.access_token) {
      if (local.indexOf("?") != -1) {
        local = local.split("?")[0];
      }

      window.location.href = local; // 重新获取code
    }
  }
  // code正常则保存微信鉴权和用户数据
  let userData = await store.dispatch("Login", { openid: wxData.openid });
  // 如果获取不到用户信息 就注册
  if (!userData) {
    // 如果获取不到用户信息 就注册然后登录
    let registerRes = await store.dispatch("Register", {
      openid: wxData.openid
    }); //注册
    await store.dispatch("Login", {
      openid: registerRes && registerRes.openid
    }); //登录
  }
}

async function analyticsRequest (to, from) {
  // 只统计页面跳转数据，不统计当前页 query 不同的数据
  // 所以这里只使用了 path, 如果需要统计 query 的，可以使用 to.fullPath
  store.dispatch("app/ClearAdSeatAndInfo"); //进方法之前先清除
  if (to.path !== from.path || to.name !== from.name) {
    // 访问监控
    let seatParams = {
      adPlacementName: to.name,
      validCode: 1,
      adPlacementProject: config.projectName
    };
    let adSeat = await store.dispatch("app/GetAdSeat", seatParams);
    if (adSeat) {
      for (let i = 0; i < adSeat.length; i++) {
        let params = {
          key: adSeat[i].advertisementKey,
          iv: adSeat[i].advertisementKey,
          secret: adSeat[i].advertisementKey,
          spaceNumber: adSeat[i].locationCode,
          accountId: adSeat[i].adPlacementId,
          requestId: `${parseTime(new Date(), "{y}{m}{d}{h}{i}{s}") +
            Math.round(Math.random() * 100)}`,
          bidFloor: adSeat[i].bidFloor,
          plateNumber: "",
          plateColor: "",
          vehicleColor: "",
          vehicleBrand: "",
          parkingDuration: "",
          width: adSeat[i].adPlacementWidth,
          height: adSeat[i].adPlacementHigh,
          device: {
            ua: window.navigator.userAgent
          },
          site: {
            domain: document.domain,
            page: to.path
          },
          user: {
            id: store.getters.token,
            idType: 0,
            profile: ""
          }
        };
      }
    }

  }
}
